export enum FilterActionTypes {
  CHANGE_SEARCH_TEXT = 'CHANGE_SEARCH_TEXT',
}
